var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGuideAccaGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H44.3334C45.6225 7 46.6667 8.04417 46.6667 9.33333V46.6667C46.6667 47.9558 45.6225 49 44.3334 49H14C11.4246 49 9.33337 46.9087 9.33337 44.3333V11.6667C9.33337 9.09125 11.4246 7 14 7Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H16.3334V49H14C11.4246 49 9.33337 46.9087 9.33337 44.3333V11.6667C9.33337 9.09125 11.4246 7 14 7Z",
    fill: "#239A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1483 31.6575C29.5775 31.6575 31.5467 29.6883 31.5467 27.2592C31.5467 24.83 29.5775 22.8608 27.1483 22.8608C24.7192 22.8608 22.75 24.83 22.75 27.2592C22.75 29.6883 24.7192 31.6575 27.1483 31.6575Z",
    fill: "#CFFCEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4637 27.9534H29.0004C28.3561 27.9534 27.8337 28.4757 27.8337 29.12V35.5834C27.8337 36.2277 28.3561 36.75 29.0004 36.75H35.4637C36.1081 36.75 36.6304 36.2277 36.6304 35.5834V29.12C36.6304 28.4757 36.1081 27.9534 35.4637 27.9534Z",
    fill: "#9EEED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9934 23.7826L33.3988 19.3493C33.0109 19.0897 32.4888 19.3668 32.4888 19.8334V28.7001C32.4888 29.1668 33.0109 29.4439 33.3988 29.1843L39.9934 24.7509C40.3375 24.5205 40.3375 24.013 39.9934 23.7826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGuideAccaGreen);
export default __webpack_public_path__ + "static/media/icon_guide_acca_green.f2461318.svg";
export { ForwardRef as ReactComponent };